import { Menu, MenuItem } from '@mui/material'
import React, { Fragment } from 'react'
import { IconCalendarBTN } from './IconManagerMeeting'
import { useTranslation } from 'react-i18next'
import { CALENDAR_VIEW } from 'constants/common'
import { color } from 'theme'
import { useMenuCC } from 'hooks'
import { ButtonTriggerFilter } from 'components/common/Button'

function getNameOfView(view) {
    return view === CALENDAR_VIEW.TIME_GRID_WEEK ? 'calendar.week' : view === CALENDAR_VIEW.TIME_GRID_DAY ? 'calendar.day' : 'calendar.list'
}

const FilterTypeMeeting = ({
    currentTypeView,
    handleChangeView
}) => {
    const { t } = useTranslation()
    const { open, anchorEl, setAnchorEl } = useMenuCC()

    const handleChangeViewSelection = (type) => {
        handleChangeView(type)
        setAnchorEl(null)
    }

    return (
        <Fragment>
            <ButtonTriggerFilter id={'btn-filter-type-meeting'} startIcon={<IconCalendarBTN />} label={t(getNameOfView(currentTypeView))} open={open} setAnchorEl={setAnchorEl}/>
            <Menu
                id="view-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'type-view',
                }}
            >
                <MenuItem sx={{ display: { xs: 'none', sm: 'flex' }, backgroundColor: currentTypeView === CALENDAR_VIEW.TIME_GRID_WEEK && color.backgroundColorChose }} onClick={() => handleChangeViewSelection(CALENDAR_VIEW.TIME_GRID_WEEK)}>{t('calendar.week')}</MenuItem>
                <MenuItem sx={{ backgroundColor: currentTypeView === CALENDAR_VIEW.TIME_GRID_DAY && color.backgroundColorChose }} onClick={() => handleChangeViewSelection(CALENDAR_VIEW.TIME_GRID_DAY)}>{t('calendar.day')}</MenuItem>
                <MenuItem sx={{ backgroundColor: currentTypeView === CALENDAR_VIEW.LIST_WEEK && color.backgroundColorChose }} onClick={() => handleChangeViewSelection(CALENDAR_VIEW.LIST_WEEK)}>{t('calendar.list')}</MenuItem>
            </Menu>
        </Fragment>
    )
}

export default FilterTypeMeeting